import { render, staticRenderFns } from "./table-plan.vue?vue&type=template&id=0ddfb424&scoped=true"
import script from "./table-plan.vue?vue&type=script&lang=js"
export * from "./table-plan.vue?vue&type=script&lang=js"
import style0 from "./table-plan.vue?vue&type=style&index=0&id=0ddfb424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfb424",
  null
  
)

export default component.exports